var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"page-footer"},[_c('b-container',[_c('div',{staticClass:"footer-content"},[_vm._v(" Contact: "),_c('a',{attrs:{"href":"mailto:psos@computational.bio"}},[_vm._v("psos@computational.bio")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }